module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/babel-runtime/core-js/promise.js
// module id = 95
// module chunks = 1